/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
// eslint-disable-next-line jira/restricted/redux
// eslint-disable-next-line jira/restricted/redux
// eslint-disable-next-line jira/restricted/redux
import type { Store } from 'redux';
import type { ReactReduxContextInstance } from 'react-redux--next/es/components/Context';
import { connect, type ConnectedComponent } from '@atlassian/jira-react-redux/src/index.tsx';
import {
	getFilter,
	getAssociatedBoards,
	getAssociatedUsers,
	getAssociatedGroups,
} from '../../state/selectors.tsx';
import type { State } from '../../state/types.tsx';
import type { Boards, Users, Groups } from '../../model/index.tsx';
import Content from './view.tsx';

const mapStateToProps = (state: State) => ({
	filter: getFilter(state),
	boards: getAssociatedBoards(state),
	users: getAssociatedUsers(state),
	groups: getAssociatedGroups(state),
});

const DeleteFiltersModalContentView: ConnectedComponent<
	({
		boards,
		groups,
		users,
	}: {
		boards: Boards;
		users: Users;
		groups: Groups;
	}) => React.JSX.Element,
	{
		context?: ReactReduxContextInstance | undefined;
		store?: Store | undefined;
	}
> = connect(mapStateToProps, {})(Content);
export default DeleteFiltersModalContentView;
